import styled from 'styled-components'

import type { ChildrenProps } from '@root/shared/react'

export const BottomNavigationContainer: React.FC<ChildrenProps> = ({
  children,
}) => {
  return (
    <Root>
      <Content>{children}</Content>
    </Root>
  )
}

const Root = styled.div`
  position: fixed;
  inset: 0;
  top: auto;
  display: grid;
  align-content: end;
  padding: 14px 12px calc(14px + var(--safe-bottom));

  border-top: 1px solid var(--backgroundA-3);
  backdrop-filter: blur(25px);

  background: linear-gradient(
    177deg,
    transparent 2.1%,
    var(--appearanceA-7) 97.76%
  );
`

const Content = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: auto;
  gap: 10px;
  justify-items: stretch;
  align-items: center;
  align-content: start;
`
